import {Injectable} from '@angular/core';
import {ActiveToast, ToastrConfig, ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    public toastr: ToastrService,
    public translateService: TranslateService,
    public liveAnnouncer: LiveAnnouncer
  ) {
  }

  async success(message: string, title?: string, toastConfig?: ToastrConfig): Promise<ActiveToast<any>> {
    const messageTranslated = message && await this.translateService.get(message).toPromise();
    const titleTranslated = title && await this.translateService.get(title).toPromise();
    const toastRef = this.toastr.success(messageTranslated, titleTranslated, toastConfig);
    setTimeout(() => {
      const toastElement: HTMLElement = document.querySelector('.toast-container');
      toastElement.setAttribute('aria-live', 'assertive');
      this.liveAnnouncer.announce(message, 'assertive');
    }, 10);

    return toastRef;
  }

  async error(message: string, title?: string, toastConfig?: ToastrConfig): Promise<ActiveToast<any>> {
    const messageTranslated = message && await this.translateService.get(message).toPromise();
    const titleTranslated = title && await this.translateService.get(title).toPromise();
    const toastRef = this.toastr.error(messageTranslated, titleTranslated, toastConfig);
    setTimeout(() => {
      const toastElement: HTMLElement = document.querySelector('.toast-container');
      toastElement.setAttribute('aria-live', 'assertive');
      this.liveAnnouncer.announce(message, 'assertive');
    }, 10);

    return toastRef;
  }

  async info(message: string, title?: string, toastConfig?: ToastrConfig): Promise<ActiveToast<any>> {
    const messageTranslated = message && await this.translateService.get(message).toPromise();
    const titleTranslated = title && await this.translateService.get(title).toPromise();
    const toastRef = this.toastr.info(messageTranslated, titleTranslated, toastConfig);
    setTimeout(() => {
      const toastElement: HTMLElement = document.querySelector('.toast-container');
      toastElement.setAttribute('aria-live', 'assertive');
      this.liveAnnouncer.announce(message, 'assertive');
    }, 10);

    return toastRef;
  }

  async warning(message: string, title?: string, toastConfig?: ToastrConfig): Promise<ActiveToast<any>> {
    const messageTranslated = message && await this.translateService.get(message).toPromise();
    const titleTranslated = title && await this.translateService.get(title).toPromise();
    const toastRef = this.toastr.warning(messageTranslated, titleTranslated, toastConfig);
    setTimeout(() => {
      const toastElement: HTMLElement = document.querySelector('.toast-container');
      toastElement.setAttribute('aria-live', 'assertive');
      this.liveAnnouncer.announce(message, 'assertive');
    }, 10);

    return toastRef;
  }

  async show(message: string, title?: string, toastConfig?: ToastrConfig): Promise<ActiveToast<any>> {
    const messageTranslated = message && await this.translateService.get(message).toPromise();
    const titleTranslated = title && await this.translateService.get(title).toPromise();
    const toastRef = this.toastr.show(messageTranslated, titleTranslated, toastConfig);
    setTimeout(() => {
      const toastElement: HTMLElement = document.querySelector('.toast-container');
      toastElement.setAttribute('aria-live', 'assertive');
      this.liveAnnouncer.announce(message, 'assertive');
    }, 10);

    return toastRef;
  }
}
